<template>
  <div id="plan">
    <!-- page intro -->
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />

        <h2>Wat staat in dit beleggingsplan?</h2>
        <p>
          Dit document is om twee redenen belangrijk. De eerste reden is dat hierin uw persoonlijke
          informatie is vastgelegd. Uw persoonlijke informatie is opgesteld aan de hand van de
          antwoorden die u op onze vragen heeft gegeven. De tweede reden is dat in dit document
          wordt beschreven hoe wij uw geld gaan beleggen. Deze informatie betreft onder andere uw
          financiële positie, uw risicobereidheid, uw beleggingsdoelstelling en uw kennis en
          ervaring op beleggingsgebied.
        </p>
        <p v-if="intakeAdmin.beleggen.brand == 'OXBY'">
          Daarnaast leggen wij in dit document vast op welke wijze OXBY uw vermogen zal beheren. U
          geeft ons hierbij het beleggingsplan dat bij u past. Het beleggingsplan bevat onder andere
          de uitgangspunten van het beleggingsbeleid.
        </p>

        <h2>Lees dit document goed en laat het ons weten als er iets niet klopt</h2>
        <p>
          Het is belangrijk dat u ons wijst op dingen die fout of niet volledig in dit
          beleggingsplan staan. Verandert er iets in uw persoonlijke omstandigheden? Of verwacht u
          dat er iets verandert? En klopt daardoor de informatie over uw persoonlijke omstandigheden
          die wij van u hebben gekregen niet meer? Dan moet u ons dat zo snel mogelijk laten weten.
          Dan beoordelen wij of we het beleggingsplan moeten veranderen. Doet u dit niet of te laat?
          Dan zijn wij niet verantwoordelijk voor de gevolgen.
        </p>
        <p>
          Stel, u gaat scheiden. Dan kan dat betekenen dat het beleggingsplan moet veranderen. Geeft
          u niet aan ons door dat u gaat scheiden? Dan kan het zo zijn dat de beleggingen die wij
          doen niet meer passen bij uw nieuwe persoonlijke omstandigheden en u bijvoorbeeld een
          beleggingsverlies niet meer kunt dragen.
        </p>

        <h2>Informatievoorziening</h2>
        <p>
          Wij houden u op de hoogte en communiceren met u via onze website, uw eigen online omgeving
          en via e-mail. Soms nemen we contact met u op via telefoon of sturen wij u een bericht via
          de post.
          <span v-if="intakeAdmin.beleggen.brand == 'OXBY'">Iedere maand</span>
          <span v-else>Ieder kwartaal</span>
          krijgt u een overzicht met de waardeontwikkeling en de
          wijze waarop uw portefeuille is samengesteld aan het einde van deze periode. Ook vindt u
          hierin alle beleggingen die wij hebben gekocht en verkocht en ziet u of en hoe uw
          portefeuille is veranderd. Tevens staat in dit overzicht vermeld welke kosten u waarvoor
          heeft betaald.
        </p>
        <p>
          Indien u vragen of opmerkingen heeft, neem dan contact met ons op via
          <template v-if="intakeAdmin.beleggen.brand == 'OXBY'">
            <b>020-555 0011</b> of ons e-mailadres <b>info@oxby.nl</b>
          </template>
        </p>
        <p>
          Wij zullen u op de hoogte stellen van onze visie op de financiële markten. Ook zullen wij
          aandacht besteden aan de wijze waarop wij uw portefeuille beheren. U ontvangt hierover van
          ons bericht. Uiteraard geven wij u ook de mogelijkheid om uw eigen wensen of veranderingen
          aan ons mede te delen. Als die wensen of veranderingen betekenen dat wij het
          beleggingsbeleid moeten veranderen, dan zullen wij u binnen een maand laten weten hoe wij
          van plan zijn dat te gaan doen.
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- page rekeninghouders-->
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />

        <h2>Rekeninghouder(s)</h2>
        <table
          v-if="intake.rekeningData.type == 'Bedrijfsrekening'"
          cellspacing="0"
          cellpadding="0"
          style="table-layout: fixed;"
        >
          <tr style="background-color:#eee">
            <td colspan="4">
              <b>{{ intake.bedrijfsData.bedrijfsnaam || 'Bedrijfsnaam' }}</b>
            </td>
          </tr>
          <tr>
            <td>Straatnaam, Huisnummer</td>
            <td>
              <b
                >{{ intake.bedrijfsData.straat }} {{ intake.bedrijfsData.huisnummer }}
                {{ intake.bedrijfsData.toevoeging }}</b
              >
            </td>
            <td>Lei-nummer</td>
            <td>
              <b>{{ intake.bedrijfsData.lei }}</b>
            </td>
          </tr>
          <tr>
            <td>Postcode, Woonplaats</td>
            <td>
              <b>{{ intake.bedrijfsData.postcode }} {{ intake.bedrijfsData.plaats }}</b>
            </td>
            <td>RSIN-nummer</td>
            <td>
              <b>{{ intake.bedrijfsData.rsin }}</b>
            </td>
          </tr>
          <tr>
            <td>Land</td>
            <td>
              <b>{{ intake.bedrijfsData.land }}</b>
            </td>
            <td>Rechtsvorm</td>
            <td>
              <b>{{
                intake.bedrijfsData.rechtsvorm === 'anders'
                ? intake.bedrijfsData.rechtsvormAnders
                : intake.bedrijfsData.rechtsvorm
              }}</b>
            </td>
          </tr>
          <tr>
            <td>Tegenrekening</td>
            <td>
              <b>{{ intake.rekeningData.iban || 'Tegenrekening' }}</b>
            </td>
            <td>KVK-nummer</td>
            <td>
              <b>{{ intake.bedrijfsData.kvk }}</b>
            </td>
          </tr>
        </table>

        <table v-if="intake.financeData.negatiefVermorgen == 'Yes'">
          <tr>
            <td>Het bedrijf heeft een negatief eigen vermogen.</td>
          </tr>
          <tr v-if="intake.financeData.uitgeleend == 'Yes'">
            <td>
              Het bedrijf heeft geld uitgeleend
              <template v-if="intake.financeData.uitgeleendU == 'Yes'">
                aan persoon zelf.
              </template>
              <template v-else>
                een prive persoon.
              </template>
            </td>
          </tr>
        </table>

        <table
          v-for="(persoon, index) in filter(intake.persoonsData, deathFilter)"
          :key="`r${index}naam`"
          cellspacing="0"
          cellpadding="0"
          style="table-layout: fixed;"
        >
          <tr style="background-color:#eee">
            <td colspan="2">
              <b>
                {{ persoon.type }} - {{ persoon.voorletters }}
                <template v-if="!persoon.voorletters">Voornaam</template>
                {{ persoon.tussenvoegsel }} {{ persoon.achternaam }}
                <template v-if="!persoon.achternaam">Achternaam</template>
                <template v-if="persoon.voornaam">({{ persoon.voornaam }})</template>
              </b>
            </td>
          </tr>
          <tr>
            <td>
              Straatnaam, Huisnummer
              <b>
                {{
                  persoon.zelfdeAdres == 'Yes' ? intake.persoonsData[0].straat : persoon.straat
                }}
                {{
                  persoon.zelfdeAdres == 'Yes'
                    ? intake.persoonsData[0].huisnummer
                    : persoon.huisnummer
                }}
                {{
                  persoon.zelfdeAdres == 'Yes'
                    ? intake.persoonsData[0].toevoeging
                    : persoon.toevoeging
                }}
              </b>
            </td>
            <td>
              Telefoonnummer
              <b>{{ persoon.telefoonnummer }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Postcode, Woonplaats
              <b>
                {{
                  persoon.zelfdeAdres == 'Yes'
                    ? intake.persoonsData[0].postcode
                    : persoon.postcode
                }}
                {{
                  persoon.zelfdeAdres == 'Yes' ? intake.persoonsData[0].plaats : persoon.plaats
                }}
              </b>
            </td>
            <td>
              E-mail <b v-if="index == 0">{{ $parent.$parent.$parent.email }}</b
              ><b v-else>{{ persoon.email }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Land
              <b>{{
                persoon.zelfdeAdres == 'Yes' ? intake.persoonsData[0].land : persoon.land
              }}</b>
            </td>
            <td>
              BSN
              <b>{{ persoon.bsn }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Geboortedatum
              <b>{{ new Date(persoon.geboorteDatum).toLocaleDateString() }}</b>
            </td>
            <td>
              Nationaliteit
              <b>{{ persoon.nationaliteit }}</b>
            </td>
          </tr>
          <tr>
            <td>
              Geboorteplaats <b>{{ persoon.geboortplaats }} ({{ persoon.geboorteland }})</b>
            </td>
            <td>
              <template v-if="index == 0 && intake.rekeningData.type != 'Bedrijfsrekening'">
                Tegenrekening <b>{{ intake.rekeningData.iban}}</b>
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- pages fin. situation-->
    <div v-for="(persoon, index) in filter(
      filter(intake.persoonsData, financeFilter),
      deathFilter,
    )" class="card" :key="`r${index}naam`">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />

        <h2>
          Financiële situatie
          {{ persoon.voorletters }}
          <span v-if="!persoon.voorletters">Voornaam</span>
          {{ persoon.tussenvoegsel }}
          {{ persoon.achternaam }}
          ({{ persoon.type }})
        </h2>

        <p>
          Hieronder staat de informatie die u aan ons heeft gegeven, indien belangrijke informatie
          ontbreekt dan vragen wij u dat aan ons door te geven. Wij kunnen namelijk bij ons
          vermogensbeheer geen rekening houden met informatie die wij niet weten.
        </p>

        <p v-if="persoon.levensonderhoud && persoon.levensonderhoud.substr(0, 2) == 'ja'">
          Wij hebben verder begrepen dat uw inkomsten uit arbeid en/of ander vermogen ruimschoots
          toereikend zijn om in uw levensonderhoud, pensioen en financiële verplichtingen te
          voorzien.
        </p>

        <table cellspacing="0" cellpadding="0">
          <tr style="background-color:#eee">
            <td>
              <b>Inkomen</b>
            </td>
          </tr>
          <tr>
            <td>
              U ontvangt inkomen
              <template v-if="persoon.inkomenType == 'Loondienst'">uit loondienst.</template>
              <template
                v-if="persoon.inkomenType == 'Zelfstandige'
                  || persoon.inkomentype == 'Eenmanszaak'
                "
              >
                als zelfstandige.
              </template>
              <template v-if="persoon.inkomenType == 'Pensioen'">
                uit AOW en/of werkgeverspensioen.
              </template>
              <template v-if="persoon.inkomenType == 'Anders'">
                uit een andere bron, namelijk {{ persoon.inkomenTypeAnders }}.
              </template>
            </td>
          </tr>
          <tr v-if="persoon.inkomenType != 'Pensioen'">
            <td>
              Uw bruto inkomen is &euro;
              {{ formatPrice(Number(persoon.jaarinkomen || 0), true) }},- per jaar.
            </td>
          </tr>
          <tr v-if="persoon.anderInkomen == 'Yes'">
            <td>
              Uw heeft extra inkomen uit {{ persoon.anderInkomenType === 'Anders'
                ? persoon.anderInkomenTypeOmschrijving
                : persoon.anderInkomenType }} en is &euro;
              {{ formatPrice(Number(persoon.anderInkomenPerJaar || 0), true) }},- per jaar.
            </td>
          </tr>
          <tr>
            <td>
              <template v-if="persoon.levensonderhoud == 'ja, en kan sparen'">
                Uw inkomsten zijn voldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}} en u kunt
                nog &euro; {{ formatPrice(Number(persoon.kanSparenBedrag || 0), true) }},- per maand
                sparen.
              </template>
              <template v-if="persoon.levensonderhoud == 'ja, en ik kan sparen'">
                Uw inkomsten zijn voldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}} en u kunt
                nog &euro; {{ formatPrice(Number(persoon.kanSparenBedrag || 0), true) }},- per maand
                sparen.
              </template>
              <template v-if="persoon.levensonderhoud == 'ja, voldoende'">
                Uw inkomsten zijn voldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}}.
              </template>
              <template v-if="persoon.levensonderhoud == 'nee, vanuit deze rekening'">
                Uw inkomsten zijn onvoldoende voor uw
                {{goalType === 'uitkerend' ? 'vaste uitgavepatroon' : 'levensonderhoud'}}, u heeft
                &euro; {{ formatPrice(Number(persoon.levensonderhoudBedragPerJaar || 0), true) }},-
                nodig van uw {{ brandname }} rekening.
              </template>
              <template v-if="persoon.levensonderhoud == 'nee, vanuit andere rekening'">
                Uw inkomsten zijn onvoldoende voor uw levensonderhoud, u heeft geld nodig van een
                rekening elders.
              </template>
            </td>
          </tr>
          <tr v-if="goalType === 'uitkerend' && persoon.manierVanLeven">
            <td v-if="persoon.levensonderhoud === 'nee, vanuit deze rekening'">
              Uw manier van leven kan {{ persoon.manierVanLeven === 'No' ? 'niet' : '' }} aangepast
              worden om voldoende inkomsten te hebben als de inkomsten van deze
              {{ intakeAdmin.beleggen.brand }} rekening lager worden of wegvallen.
            </td>
            <td v-else>
              Uw manier van leven
                {{ persoon.manierVanLeven === 'No'
                  ? 'moet aangepast'
                  : 'hoeft niet aangepast te'
                }} worden als de inkomsten van deze {{ intakeAdmin.beleggen.brand }} rekening lager
              worden of wegvallen.
            </td>
          </tr>
        </table>

        <table cellspacing="0" cellpadding="0">
          <tr style="background-color:#eee">
            <td>
              <b
                >Bruto pensioen
                <template v-if="persoon.inkomenType != 'Pensioen'">(verwacht)</template></b
              >
            </td>
          </tr>
          <tr>
            <td>
              Uw AOW, inclusief eventueel werkgeverspensioen, is totaal &euro;
              {{ formatPrice(Number(persoon.pensioen || 0), true) }},- per jaar.<br />
            </td>
          </tr>
          <tr>
            <td>
              Uw schatting aanvullend pensioen (box 1) is &euro;
              {{ formatPrice(Number(
                persoon.pensioenHeeftAanvullend == 'Yes' ? persoon.pensioenAanvullend || 0 : 0
                ), true)
              }},-
              per jaar.
            </td>
          </tr>
          <tr v-if="persoon.persioenBeheer == 'Yes'">
            <td>U heeft pensioen opgebouwd binnen {{ persoon.pensioenBeheerBV }}</td>
          </tr>
          <tr>
            <td>
              <template v-if="persoon.pensioenToereikend == 'No'"
                >U heeft aangegeven dat dit pensioen niet toereikend is.</template
              >
              <template v-else>U heeft aangegeven dat uw pensioen toereikend is.</template>
            </td>
          </tr>
        </table>

        <table cellspacing="0" cellpadding="0">
          <tr style="background-color:#eee">
            <td>
              <b>Bezittingen</b>
            </td>
          </tr>
          <tr v-if="persoon.spaarrekening == 'Yes'">
            <td>
              Op uw betaal- of spaarrekening(en) heeft u totaal &euro;
              {{
                formatPrice(
                  Number(persoon.spaarrekeningBedrag || 0) +
                    Number(persoon.spaarrekeningBedrag2 || 0) +
                    Number(persoon.spaarrekeningBedrag3 || 0),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr v-if="persoon.beleggingen == 'Yes'">
            <td>
              Aan beleggingen heeft u totaal &euro;
              {{
                formatPrice(
                  Number(persoon.beleggingenBedrag || 0) +
                    Number(persoon.beleggingenMeerBedrag || 0) +
                    Number(persoon.beleggingenNogMeerBedrag || 0),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr v-if="persoon.eigenwoning == 'Yes'">
            <td>
              De vrije verkoopwaarde van uw eigen woning is &euro;
              {{ formatPrice(Number(persoon.eigenwoningVrijeverkoopwaarde || 0), true) }},-
            </td>
          </tr>
          <tr v-if="persoon.onroerendgoed == 'Yes'">
            <td>
              De vrije verkoopwaarde van overig onroerende goed is &euro;
              {{ formatPrice(Number(persoon.onroerendgoedVrijeverkoopwaarde || 0), true) }},-
              <template v-if="persoon.onroerendgoedCommercieel === 'Yes'
                && persoon.onroerendgoedBedragPerJaar"
              >
                met een jaarlijks inkomen van &euro; {{
                formatPrice(Number(persoon.onroerendgoedBedragPerJaar), true)
                }},-
                <template v-if="persoon.onroerendgoedObjecten">
                  voor {{persoon.onroerendgoedObjecten}}
                  {{persoon.onroerendgoedObjecten == 1 ? 'object.' : 'objecten.'}}
                </template>
              </template>
            </td>
          </tr>
          <tr
            v-if="
              persoon.spaarrekening != 'Yes' &&
                persoon.beleggingen != 'Yes' &&
                persoon.eigenwoning != 'Yes' &&
                persoon.onroerendgoed != 'Yes'
            "
          >
            <td>U heeft geen bezittingen.</td>
          </tr>
        </table>

        <p style="font-style:italic">
          Wij adviseren om altijd een gedeelte van uw vermogen te sparen. Sparen is geen beleggen.
          Beleggen kent grotere risico’s dan sparen.
        </p>

        <table cellspacing="0" cellpadding="0" v-if="persoon.eigenwoning != 'Yes'">
          <tr style="background-color:#eee">
            <td>
              <b>Huurlasten</b>
            </td>
          </tr>
          <tr>
            <td>
              U betaalt aan huur &euro; {{ formatPrice(Number(persoon.huurlasten) || 0, true) }},-
              per maand.
            </td>
          </tr>
        </table>

        <table cellspacing="0" cellpadding="0" v-if="persoon.hypotheekEigenWoning == 'Yes'">
          <tr style="background-color:#eee">
            <td>
              <b>Hypotheek eigen woning</b>
            </td>
          </tr>
          <tr>
            <td v-if="persoon.hypotheekEigenWoningRenteType == 'vast'">
              Hypotheek ({{ persoon.hypotheekEigenWoningType }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoningWaarde || 0), true) }},-
              <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
                bij {{persoon.hypotheekEigenWoningInstantie === 'Anders'
                ? persoon.hypotheekEigenWoningInstantieOmschrijving
                : persoon.hypotheekEigenWoningInstantie }}
              </template> met een
              rente van {{ formatPrice(persoon.hypotheekEigenWoningRente / 100, false, 1) }}% (<em
                >{{ persoon.hypotheekEigenWoningRenteType }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekEigenWoningLooptijd).toLocaleDateString() }}.
            </td>
            <td v-else>
              Hypotheek ({{ persoon.hypotheekEigenWoningType }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoningWaarde || 0), true) }},-
              <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
                bij {{persoon.hypotheekEigenWoningInstantie === 'Anders'
                ? persoon.hypotheekEigenWoningInstantieOmschrijving
                : persoon.hypotheekEigenWoningInstantie }}
              </template> met een
              {{ persoon.hypotheekEigenWoningRenteType }}e rente.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekEigenWoning2 == 'Yes'">
            <td v-if="persoon.hypotheekEigenWoning2RenteType == 'vast'">
              Hypotheek ({{ persoon.hypotheekEigenWoning2Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning2Waarde || 0), true) }},-
              <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
                bij {{persoon.hypotheekEigenWoning2Instantie === 'Anders'
                ? persoon.hypotheekEigenWoning2InstantieOmschrijving
                : persoon.hypotheekEigenWoning2Instantie }}
              </template> met een
              rente van {{ formatPrice(persoon.hypotheekEigenWoning2Rente / 100, false, 1) }}% (<em
                >{{ persoon.hypotheekEigenWoning2RenteType }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekEigenWoning2Looptijd).toLocaleDateString() }}.
            </td>
            <td v-else>
              Hypotheek ({{ persoon.hypotheekEigenWoning2Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning2Waarde || 0), true) }},-
              <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
                bij {{persoon.hypotheekEigenWoning2Instantie === 'Anders'
                ? persoon.hypotheekEigenWoning2InstantieOmschrijving
                : persoon.hypotheekEigenWoning2Instantie }}
              </template> met een
              {{ persoon.hypotheekEigenWoning2RenteType }}e rente.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekEigenWoning3 == 'Yes'">
            <td v-if="persoon.hypotheekEigenWoning3RenteType == 'vast'">
              Hypotheek ({{ persoon.hypotheekEigenWoning3Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning3Waarde || 0), true) }},-
              <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
                bij {{persoon.hypotheekEigenWoning3Instantie === 'Anders'
                ? persoon.hypotheekEigenWoning3InstantieOmschrijving
                : persoon.hypotheekEigenWoning3Instantie }}
              </template> met een
              rente van {{ formatPrice(persoon.hypotheekEigenWoning3Rente / 100, false, 1) }}% (<em
                >{{ persoon.hypotheekEigenWoning3RenteType }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekEigenWoning3Looptijd).toLocaleDateString() }}.
            </td>
            <td v-else>
              Hypotheek ({{ persoon.hypotheekEigenWoning3Type }}) van &euro;
              {{ formatPrice(Number(persoon.hypotheekEigenWoning3Waarde || 0), true) }},-
              <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
                bij {{persoon.hypotheekEigenWoning3Instantie === 'Anders'
                ? persoon.hypotheekEigenWoning3InstantieOmschrijving
                : persoon.hypotheekEigenWoning3Instantie }}
              </template> met een
              {{ persoon.hypotheekEigenWoning3RenteType }}e rente.
            </td>
          </tr>
        </table>

        <table cellspacing="0" cellpadding="0" v-if="persoon.hypotheekOnroerendGoed == 'Yes'">
          <tr style="background-color:#eee">
            <td>
              <b>Hypotheek overig onroerend goed</b>
            </td>
          </tr>
          <tr>
            <td>
              Hypotheek ({{ persoon.hypotheekOnroerendGoedType }}) op overig onroerend goed van
              &euro; {{ formatPrice(Number(persoon.hypotheekOnroerendGoedWaarde || 0), true) }},-
              met een rente van
              {{ formatPrice(persoon.hypotheekOnroerendGoedRente / 100, false, 1) }}% (<em>{{
                persoon.hypotheekOnroerendGoedRenteType
              }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekOnroerendGoedLooptijd).toLocaleDateString() }}.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekOnroerendGoed2 == 'Yes'">
            <td>
              Hypotheek ({{ persoon.hypotheekOnroerendGoed2Type }}) op overig onroerend van &euro;
              {{ formatPrice(Number(persoon.hypotheekOnroerendGoed2Waarde || 0), true) }},- met
              een rente van
              {{ formatPrice(persoon.hypotheekOnroerendGoed2Rente / 100, false, 1) }}% (<em>{{
                persoon.hypotheekOnroerendGoed2RenteType
              }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekOnroerendGoed2Looptijd).toLocaleDateString() }}.
            </td>
          </tr>
          <tr v-if="persoon.hypotheekOnroerendGoed3 == 'Yes'">
            <td>
              Hypotheek ({{ persoon.hypotheekOnroerendGoed3Type }}) op overig onroerend van &euro;
              {{ formatPrice(Number(persoon.hypotheekOnroerendGoed3Waarde || 0), true) }},- met
              een rente van
              {{ formatPrice(persoon.hypotheekOnroerendGoed3Rente / 100, false, 1) }}% (<em>{{
                persoon.hypotheekOnroerendGoed3RenteType
              }}</em
              >) met nog een vaste rente periode tot
              {{ new Date(persoon.hypotheekOnroerendGoed3Looptijd).toLocaleDateString() }}.
            </td>
          </tr>
        </table>

        <table v-if="persoon.schulden == 'Yes'">
          <tr style="background-color:#eee">
            <td><b>Overige verplichtingen</b></td>
          </tr>
          <tr>
            <td>
              U heeft een {{ persoon.schuldenType }} van &euro;
              {{ formatPrice(Number(persoon.schuldenBedrag || 0), true) }},- of per maand &euro;
              {{ formatPrice(Number(persoon.schuldenMaandelijks), true) }},-.
            </td>
          </tr>
          <tr v-if="persoon.schuldenMeer == 'Yes'">
            <td>
              U heeft een {{ persoon.schuldenMeerType }} van &euro;
              {{ formatPrice(Number(persoon.schuldenMeerBedrag || 0), true) }},- of per maand
              &euro; {{ formatPrice(Number(persoon.schuldenMeerMaandelijks), true) }},-.
            </td>
          </tr>
          <tr v-if="persoon.schuldenMeer2 == 'Yes'">
            <td>
              U heeft een {{ persoon.schuldenMeer2Type }} van &euro;
              {{ formatPrice(Number(persoon.schuldenMeer2Bedrag || 0), true) }},- of per maand
              &euro; {{ formatPrice(Number(persoon.schuldenMeer2Maandelijks), true) }},-.
            </td>
          </tr>
          <tr v-if="persoon.schuldenMeer3 == 'Yes'">
            <td>
              U heeft een {{ persoon.schuldenMeer3Type }} van &euro;
              {{ formatPrice(Number(persoon.schuldenMeer3Bedrag || 0), true) }},- of per maand
              &euro; {{ formatPrice(Number(persoon.schuldenMeer3Maandelijks), true) }},-.
            </td>
          </tr>
        </table>

        <p style="font-style:italic" v-if="'schulden'">
          Let op, beleg niet met geleend geld. Los eerst uw schulden af.
        </p>
        <p style="font-style:italic" v-else>
          U heeft of verwacht geen periodieke financiële verplichtingen waarmee wij rekening
          moeten houden.
        </p>
      </div>

      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- page gez. fin. situatie -->
    <div
      class="card"
      v-if="filter(filter(intake.persoonsData, financeFilter), deathFilter).length > 1"
    >
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />

        <h2>
          Gezamenlijke financiële situatie
        </h2>
        <p>
          Hieronder staat de informatie die u aan ons heeft gegeven, indien belangrijke informatie
          ontbreekt dan vragen wij u dat aan ons door te geven. Wij kunnen namelijk bij ons
          vermogensbeheer geen rekening houden met informatie die wij niet weten.
        </p>

        <table cellspacing="0" cellpadding="0">
          <tr style="background-color:#eee">
            <td>
              <b>Inkomen</b>
            </td>
          </tr>
          <tr>
            <td>
              Bruto jaarinkomen &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), (o) => Number(o.jaarinkomen || 0)),
                  true,
                )
              }},-.
            </td>
          </tr>
          <tr>
            <td>
              Sparen &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), (o) => Number(o.kanSparenBedrag || 0)),
                  true,
                )
              }},- per maand.
            </td>
          </tr>
        </table>

        <table cellspacing="0" cellpadding="0">
          <tr style="background-color:#eee">
            <td>
              <b>Pensioen (verwacht)</b>
            </td>
          </tr>
          <tr>
            <td>
              Werkgeverspensioen &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), (o) => Number(o.pensioen || 0)),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Schatting aanvullend pensioen (box 1) &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), (o) => Number(o.pensioenAanvullend || 0)),
                  true,
                )
              }},-
            </td>
          </tr>
        </table>

        <table cellspacing="0" cellpadding="0">
          <tr style="background-color:#eee">
            <td colspan="2" style="background-color:#eee">
              <b>Bezittingen</b>
            </td>
          </tr>
          <tr>
            <td>
              Betaal- of spaarrekeningen &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(
                      filter(intake.persoonsData, financeFilter),
                      deathFilter,
                    ),
                    (o) =>
                      Number(o.spaarrekeningBedrag || 0) +
                      Number(o.spaarrekeningBedrag2 || 0) +
                      Number(o.spaarrekeningBedrag3 || 0),
                  ),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Beleggingen &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(
                      filter(intake.persoonsData, financeFilter),
                      deathFilter,
                    ),
                    (o) =>
                      Number(o.beleggingenBedrag || 0) +
                      Number(o.beleggingenMeerBedrag || 0) +
                      Number(o.beleggingenNogMeerBedrag || 0),
                  ),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Woning(en) &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), (o) => Number(o.eigenwoningVrijeverkoopwaarde || 0)),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Overig onroerend goed &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), (o) =>
                    Number(o.onroerendgoedVrijeverkoopwaarde || 0),
                  ),
                  true,
                )
              }},-
            </td>
          </tr>
        </table>

        <p style="font-style:italic">
          Wij adviseren om altijd een gedeelte van uw vermogen te sparen. Sparen is geen beleggen.
          Beleggen kent grotere risico’s dan sparen.
        </p>

        <table cellspacing="0" cellpadding="0">
          <tr class="tablehead">
            <td>
              <b>Verplichtingen</b>
            </td>
          </tr>
          <tr>
            <td>
              Huur per maand &euro;
              {{
                formatPrice(
                  sumBy(filter(
                    filter(intake.persoonsData, financeFilter),
                    deathFilter,
                  ), (o) => Number(o.huurlasten || 0)),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Totale hypotheekschuld eigen woning &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    (o) =>
                      Number(o.hypotheekEigenWoningWaarde || 0) +
                      Number(o.hypotheekEigenWoning2Waarde || 0) +
                      Number(o.hypotheekEigenWoning3Waarde || 0),
                  ),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Totale hypotheekschuld onroerend goed &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    (o) =>
                      Number(o.hypotheekOnroerendGoedWaarde || 0) +
                      Number(o.hypotheekOnroerendGoed2Waarde || 0) +
                      Number(o.hypotheekOnroerendGoed3Waarde || 0),
                  ),
                  true,
                )
              }},-
            </td>
          </tr>
          <tr>
            <td>
              Totale overige verplichtingen &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    (o) =>
                      Number(o.schuldenBedrag || 0) +
                      Number(o.schuldenMeerBedrag || 0) +
                      Number(o.schuldenMeer2Bedrag || 0) +
                      Number(o.schuldenMeer3Bedrag || 0),
                  ),
                  true,
                )
              }},-
            </td>
          </tr>

          <tr></tr>
          <tr>
            <td>
              Overige verplichting per maand &euro;
              {{
                formatPrice(
                  sumBy(
                    filter(filter(intake.persoonsData, financeFilter), deathFilter),
                    (o) =>
                      Number(o.schuldenMaandelijks || 0) +
                      Number(o.schuldenMeerMaandelijks || 0) +
                      Number(o.schuldenMeer2Maandelijks || 0) +
                      Number(o.schuldenMeer3Maandelijks || 0),
                  ),
                  true,
                )
              }},-
            </td>
          </tr>
        </table>

        <p style="font-style:italic" v-if="'schulden'">
          Let op, beleg niet met geleend geld. Los eerst uw schulden af.
        </p>
        <p style="font-style:italic" v-else>
          U heeft of verwacht geen periodieke financiële verplichtingen waarmee wij rekening moeten
          houden.
        </p>
      </div>

      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- page doelstelling -->
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />

        <h2>Doelstelling</h2>
        <p>
          Wij adviseren u om voor elke doelstelling een apart beleggingsbeleid te gebruiken. Bij
          elke doelstelling adviseren wij ook aparte rekeningen te openen zodat u precies ziet welke
          beleggingen voor welke doelstelling bestemd zijn.
        </p>

        <table>
          <tr v-if="redo === 0">
            <td>
              Uw doel is {{ typeToGoal }} en u start met &euro;
              {{ formatPrice(Number(intake.goalData.vermogen || 0), true) }},-
            </td>
          </tr>
          <tr v-if="redo === 1">
            <td>
              Uw doel is {{ typeToGoal }}, met een portefeuille waarde van &euro;
              {{ formatPrice(Number(portValue > -1 ? portValue : 0), true) }},- en een extra
              inleg van &euro;&nbsp;{{ formatPrice(Number(intake.goalData.vermogen || 0), true) }},-
            </td>
          </tr>
          <tr>
            <td>
              U heeft daarvoor een doelvermogen opgegeven van &euro;
              {{ formatPrice(Number(intake.goalData.doel || 0), true) }},-
            </td>
          </tr>
          <tr>
            <td v-if="intake.goalData.targetDate">
              U kunt tot {{ new Date(intake.goalData.targetDate).toLocaleDateString() }} beleggen om
              uw doel te realiseren.
            </td>
            <td v-else>
              U kunt {{ intake.goalData.looptijd }} jaar beleggen om uw doel te realiseren.
            </td>
          </tr>
        </table>

        <p style="font-style:italic">
          Wij houden geen rekening met belastingen die u eventueel nog moet betalen naar aanleiding
          van het verkrijgen van uw vermogen waarmee u bij ons komt beleggen.
        </p>

        <table>
          <tr class="tablehead">
            <td>
              <b>Stortingen &amp; onttrekkingen</b>
            </td>
          </tr>
          <tr>
            <td>
              <template v-if="intake.goalData.stortingen == 'Yes'">
                U gaat
                <span style="text-transform:lowercase">{{
                  intake.goalData.stortingenInterval
                }}</span>
                &euro; {{ formatPrice(Number(intake.goalData.stortingenBedrag || 0), true) }},-
                bijstorten.
              </template>
              <template v-else>U heeft aangegeven niet periodiek te gaan bijstorten.</template>
            </td>
          </tr>
          <tr>
            <td>
              <template v-if="intake.goalData.onttrekkingen == 'Yes'">
                U gaat over {{ intake.goalData.onttrekkingenStart }} jaar per
                {{ intake.goalData.onttrekkingenInterval }} &euro;
                {{ formatPrice(Number(intake.goalData.onttrekkingenBedrag || 0), true) }},-
                onttrekken.
              </template>
              <template v-else>U heeft aangegeven niet periodiek te gaan onttrekken.</template>
            </td>
          </tr>
        </table>

        <p style="font-style:italic">
          U begrijpt dat de kans bestaat dat uw doelvermogen aan het einde van de looptijd niet
          wordt gehaald. U heeft aangegeven dat u het risico van het niet halen van uw doelstelling
          accepteert.
        </p>

        <h2>Risicobereidheid</h2>
        <p>
          Aan beleggen zijn risico's verbonden. Deze risico's trachten wij zo goed mogelijk voor u
          te beheersen. Wij kunnen deze echter nimmer voorzien of voorkomen. In zijn algemeenheid
          geldt dat naarmate een hoger rendement wordt nagestreefd, de risico's toenemen. Deze
          risico's resulteren niet alleen in de mogelijkheid dat het verwachte of beoogde
          doelvermogen niet wordt behaald, maar ook in tussentijdse of uiteindelijke verliezen.
          Zelfs als over een langere periode wordt belegd, kan beleggen verlies opleveren.
        </p>

        <div class="box">
          Het kan zijn dat de waarde van de beleggingen sneller of meer daalt dan u verwacht. U
          heeft aangegeven dat u zich zorgen maakt bij een tussentijdse daling van
          {{ 100 - intake.goalData.warning }}% op uw inleg naar een portefeuillewaarde van circa
          &euro;
          {{
            formatPrice(
              ((Number(intake.goalData.vermogen) + Number($parent.$parent.$parent.portValue) || 0) /
                100) *
                parseInt(intake.goalData.warning),
              true,
            )
          }},-. Deze waarde zal in verhouding worden aangepast bij toekomstige stortingen en/of
          onttrekkingen.
        </div>

        <p>
          Rond het moment van de aangegeven waarde zullen wij u op de hoogte brengen. U kunt dan
          beslissen of u wilt overleggen om het beleggingsbeleid aan te passen. Dit kan door
          bijvoorbeeld daadwerkelijk verlies te nemen of verdere risico's te beperken door de
          samenstelling van uw portefeuille aan te passen.
        </p>
      </div>

      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- page kennis -->
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />
        <h2>
          Kennis en ervaring
          {{ intake.persoonsData[0].voorletters }}
          {{ intake.persoonsData[0].tussenvoegsel }}
          {{ intake.persoonsData[0].achternaam }}
        </h2>
        <p>
          Uw hoogst genoten opleiding valt binnen {{ intake.experienceData.opleiding }}.
          <template
            v-if="financeFilter(intake.persoonsData[0])
            && intake.persoonsData[0].inkomenType !== 'Anders'"
          >
            U bent
            <template v-if="intake.persoonsData[0].inkomenType == 'Pensioen'">
              met pensioen en was
            </template>
            <template v-else>
              momenteel
            </template>
            werkzaam als {{ intake.persoonsData[0].beroep }}.
          </template>
          <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
            Samenvattend kan worden gesteld dat u een
            <template v-if="intake.experienceData.ervaring != 'Yes'">
              onervaren belegger bent en nauwelijks kennis op het gebied van beleggen heeft.
            </template>
            <template v-else>
              <template
                v-if="
                  intake.experienceData.ervaringAandelenWanneer == 'meer dan 5 jaar geleden' ||
                    intake.experienceData.ervaringTrackersWanneer == 'meer dan 5 jaar geleden' ||
                    intake.experienceData.ervaringObligatiesWanneer == 'meer dan 5 jaar geleden' ||
                    intake.experienceData.ervaringOptiesWanneer == 'meer dan 5 jaar geleden'
                "
              >
                ervaren belegger bent en een ruime kennis op het gebied van beleggen heeft.
              </template>
              <template v-else>
                belegger bent met enige beleggingskennis.
              </template>
            </template>
          </template>
        </p>

        <p>
          U heeft aangegeven het document 'risico's &amp; kenmerken van effecten' te hebben gelezen
          en begrepen.
        </p>

        <p>
          In essentie komt vermogensbeheer erop neer dat wij voor u beleggingsbeslissingen nemen.
          Dat betekent dat wij zonder uw voorafgaande toestemming, beslissen waarin wordt belegd en
          wat er wordt verkocht. Uiteraard doen we dat niet zomaar. Wij maken van te voren afspraken
          met u over de wijze hoe wij gaan beleggen. Het is uiteindelijk uw geld. Deze afspraken
          hebben we vastgelegd in dit document. Dit document noemen wij het beleggingsplan.
        </p>

        <template v-if="intakeAdmin.beleggen.brand !== 'OXBY'">
          <p v-if="intake.experienceData.ervaringVermogensbeheer == 'Yes'">
            Tot slot bevestigen wij dat u heeft aangegeven bekend te zijn met de aard van onze
            dienstverlening, vermogensbeheer.
          </p>
          <p v-else>
            Tot slot bevestigen wij dat u heeft aangegeven nog niet bekend te zijn met de aard van
            onze dienstverlening, vermogensbeheer. Hieronder lees u de beschrijving.
          </p>
        </template>

        <h2>Beleggingsbeleid</h2>
        <p>
          Op basis van de ingewonnen informatie komen wij hierbij overeen een beleggingsbeleid voor
          u te gaan voeren dat kan worden gekwalificeerd als het beleid:
        </p>
        <div class="box">
          {{ intakeAdmin.beleggen.profile }}
        </div>

        <p>
          U dient zich altijd te realiseren dat zelfs bij een laag risicoprofiel onvoorziene
          situaties tot gevolg kunnen hebben dat de waarde van uw portefeuille sterk negatief wordt
          beïnvloed. Dat kunnen wij nooit uitsluiten. U moet hierbij denken aan de gevolgen van
          bijvoorbeeld een faillissement, terroristische aanslag (zoals de aanslagen van 11
          september 2001), eurocrisis of een impactvolle wetswijziging.
        </p>
        <p>
          {{ brandname }} belegt in trackers met aandelen van de grootste bedrijven wereldwijd, de
          MSCI World index. Afhankelijk van marktomstandigheden kan {{ brandname }} een deel van uw
          aandelentrackers verkopen en koopt daarvoor trackers met Duitse staatsobligaties terug.
          Elk profiel bij {{ brandname }} kent verder een eigen verdeling tussen aandelen- en
          obligatietrackers. {{ brandname }} koopt ook vastgoed en afhankelijk van het risicoprofiel
          staatsobligatie- en bedrijfsobligatietrackers.
        </p>

        <h2>Spreiding en controle</h2>
        <p>
          Om een goed gespreide portefeuille samen te stellen belegt {{ brandname }} voor u in
          trackers. Trackers volgen een index en hebben daarom dezelfde spreiding als de index.
          Tijdens het kiezen van de meest geschikte trackers wordt rekening gehouden met hoe de
          trackers zijn opgezet. Niet alle trackers werken hetzelfde.
        </p>
        <p>
          Bij {{ brandname }} beleggen wij in meerdere sectoren. Bij het innemen van een positie
          wordt altijd gecontroleerd of dit tot een overweging in een bepaalde sector leidt. Zo
          wordt het risico beperkt dat een slechtlopende sector een te grote invloed heeft op de
          gehele portefeuille.
        </p>
        <p>
          Ook de verdeling die bij een bepaald profiel hoort wordt door {{ brandname }} in de gaten
          gehouden. Het kan natuurlijk voorkomen dat aandelen sneller in waarde stijgen dan
          obligaties. Hierdoor kan de verdeling afwijken t.o.v. de oorspronkelijk verdeling.
          {{ brandname }} zal wanneer nodig één keer per jaar de verdeling van uw portefeuille
          terugbrengen binnen de oorspronkelijke bandbreedtes.
        </p>
      </div>

      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- page beleggingsbeleid -->
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />

        <h2>Duurzaamheidsvoorkeuren</h2>
        <template v-if="intake.rekeningData.sustainability">
          <p v-if="intake.rekeningData.sustainability === 'A'">
            Wij bevestigen dat u akkoord gaat dat uw portefeuille aansluit op uw risicoprofiel maar
            niet op duurzaamheidsvoorkeuren. Daarmee geeft u aan dat voor u onze totale
            dienstverlening voorgaat op  het beleggen met duurzaamheidsvoorkeuren.
          </p>
          <p v-else-if="intake.rekeningData.sustainability === 'B'">
            Wij bevestigen dat u akkoord gaat dat uw portefeuille is samengesteld zonder
            duurzaamheidsvoorkeuren.
          </p>
          <p v-else>
            Wij bevestigen dat u akkoord gaat dat uw portefeuille is samengesteld zonder
            duurzaamheidsvoorkeuren. U heeft ons laten weten dat voor u onze totale
            dienstverlening voorgaat op  het beleggen met duurzaamheidsvoorkeuren.
          </p>
        </template>
        <p v-else>
          Aan de hand van de vragen over o.a. uw financiële situatie en uw risicobereidheid wordt uw
          risicoprofiel vastgesteld. Na deze vragen hebben we u uitleg gegeven over
          duurzaamheidsvoorkeuren. Vervolgens hebben wij aan u de vraag gesteld of u op dit moment
          duurzaamheidsvoorkeuren heeft. Hierop heeft u
          <b>{{ intake.rekeningData.sustainabilityPreference === 'Yes' ? `"ja"` : `"nee"`}}</b>
          geantwoord.
        </p>

        <h2>Waardeontwikkeling</h2>
        <p>
          De risicowijzer die bij uw maximale beleggingsbeleid hoort vindt u hieronder. Deze geeft
          de beweeglijkheid (volatiliteit) aan van de beleggingen. Dit wil zeggen de hoogte en
          frequentie van de koersschommelingen van uw beleggingen indien deze zouden zijn
          samengesteld conform <b>beleggingsbeleid {{ intakeAdmin.beleggen.maxProfile }}</b
          >.
        </p>
        <p>
          U ziet hieronder een overzicht van de waardeontwikkeling, tussentijdse
          waardenschommelingen en kansen op verlies over een 1-jaars, 5-jaars en 10-jaars periode.
          Wij nemen als startpunt € 50.000,-.
        </p>
        <p>
          Historische ontwikkelingen, macro-economische uitgangspunten en rendement- en
          risicoverwachtingen vormen de basis voor de vermogensverwachting. De verschillende
          scenario's zijn te zien als mogelijke vermogens&shy;ontwikkelingen in de toekomst. Hiermee
          kunnen de gevolgen van diverse economische ontwikkelingen voor uw rendement en
          haalbaarheid inzichtelijk worden gemaakt. In de vermogensverwachting ziet u informatie
          over een slechte-, normale en goede markt van het voor u geselecteerde maximale
          beleggingsbeleid. Ondanks dat wij de prognoses en verwachtingen baseren op betrouwbaar
          geachte (statistische) uitgangspunten, is er geen garantie dat uw doelstelling
          daadwerkelijk behaald wordt.
        </p>

        <table
          style="margin-bottom:0;"
          v-if="this.intakeAdmin.beleggen.maxProfile === 'Oxby - Laag'"
        >
          <tr class="tablehead">
            <td style="font-weight:600; width:150px;">Beleggingsbeleid Laag</td>
            <td style="border-left:1px solid #ccc">1 jaar</td>
            <td>5 jaar</td>
            <td>10 jaar</td>
          </tr>
          <tr style="color:#aaa;">
            <td>Slechte markt</td>
            <td style="border-left:1px solid #e4e4e4">-9,7% &euro; 45.143</td>
            <td>-9,9% &euro; 45.063</td>
            <td>1,9% &euro; 50.932</td>
          </tr>
          <tr style="border-top:none;">
            <td>Normale markt</td>
            <td style="border-left:1px solid #e4e4e4">3,4% &euro; 51.698</td>
            <td>22,0% &euro; 61.021</td>
            <td>56,4% &euro; 78.194</td>
          </tr>
          <tr style="border-top:none; color:#aaa;">
            <td>Goede markt</td>
            <td style="border-left:1px solid #e4e4e4">18,4% &euro; 59.204</td>
            <td>65,3% &euro; 82.629</td>
            <td>140,1% &euro; 120.050</td>
          </tr>
          <tr class="tablehead">
            <td style="width:150px;">Kans op verlies</td>
            <td style="border-left:1px solid #ccc">32,7%</td>
            <td>13,6%</td>
            <td>4,2%</td>
          </tr>
        </table>

        <table
          style="margin-bottom:0;"
          v-if="this.intakeAdmin.beleggen.maxProfile === 'Oxby - Midden'"
        >
          <tr class="tablehead">
            <td style="font-weight:600; width:150px;">Beleggingsbeleid Midden</td>
            <td style="border-left:1px solid #ccc">1 jaar</td>
            <td>5 jaar</td>
            <td>10 jaar</td>
          </tr>
          <tr style="color:#aaa;">
            <td>Slechte markt</td>
            <td style="border-left:1px solid #e4e4e4">-14,5% &euro; 42.738</td>
            <td>-17,6% &euro; 41.200</td>
            <td>-8,8% &euro; 45.611</td>
          </tr>
          <tr style="border-top:none;">
            <td>Normale markt</td>
            <td style="border-left:1px solid #e4e4e4">5,0% &euro; 52.488</td>
            <td>30,5% &euro; 65.231</td>
            <td>74,7% &euro; 87.353</td>
          </tr>
          <tr style="border-top:none; color:#aaa;">
            <td>Goede markt</td>
            <td style="border-left:1px solid #e4e4e4">28,9% &euro; 64.462</td>
            <td>106,6% &euro; 103.277</td>
            <td>234,6% &euro; 167.297</td>
          </tr>
          <tr class="tablehead">
            <td style="width:150px;">Kans op verlies</td>
            <td style="border-left:1px solid #ccc">33,8%</td>
            <td>16,7%</td>
            <td>7,8%</td>
          </tr>
        </table>

        <table
          style="margin-bottom:0;"
          v-if="this.intakeAdmin.beleggen.maxProfile === 'Oxby - Hoog'"
        >
          <tr class="tablehead">
            <td style="font-weight:bold; width:150px;">Beleggingsbeleid Hoog</td>
            <td style="border-left:1px solid #ccc">1 jaar</td>
            <td>5 jaar</td>
            <td>10 jaar</td>
          </tr>
          <tr style="color:#aaa;">
            <td>Slechte markt</td>
            <td style="border-left:1px solid #e4e4e4">-19,8% &euro; 40.395</td>
            <td>-25,0% &euro; 37.515</td>
            <td>-18,8% &euro; 40.611</td>
          </tr>
          <tr style="border-top:none;">
            <td>Normale markt</td>
            <td style="border-left:1px solid #e4e4e4">6,6% &euro; 53.278</td>
            <td>39,3% &euro; 69.669</td>
            <td>94,9% &euro; 97.460</td>
          </tr>
          <tr style="border-top:none; color:#aaa;">
            <td>Goede markt</td>
            <td style="border-left:1px solid #e4e4e4">40,5% &euro; 70.271</td>
            <td>158,8% &euro; 129.380</td>
            <td>367,8% &euro; 233.887</td>
          </tr>
          <tr class="tablehead">
            <td style="width:150px;">Kans op verlies</td>
            <td style="border-left:1px solid #ccc">34,5%</td>
            <td>18,7%</td>
            <td>10,4%</td>
          </tr>
        </table>
      </div>

      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- page port -->
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />

        <h2>Samenstelling portefeuille</h2>
        <p>
          Op basis van uw risicoprofiel, uw wensen en doelstellingen spreken wij af uw portefeuille
          op de onderstaande wijze samen te stellen.
        </p>
        <table v-if="intakeAdmin.beleggen.profile == 'Oxby - Hoog'">
          <tr style="background-color:#eee">
            <td><b>Profiel OXBY Hoog</b></td>
            <td>minimaal (circa)</td>
            <td>maximaal (circa)</td>
            <td rowspan="6" style="text-align:center;border-left:1px solid #ccc;">
              <img src="../../assets/risk/risicometer4.6-6.0.svg" width="100" />
            </td>
          </tr>
          <tr>
            <td>Aandelen ontwikkelde markten</td>
            <td>55%</td>
            <td>95%</td>
          </tr>
          <tr>
            <td>Vastgoed wereldwijd</td>
            <td>5%</td>
            <td>5%</td>
          </tr>
          <tr>
            <td>Staatsleningen euro</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td>Investment grade bedrijfsobligaties euro</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td>Duitse staatsleningen euro</td>
            <td>0%</td>
            <td>40%</td>
          </tr>
          <tr>
            <td>Geldmarkt</td>
            <td>0%</td>
            <td>5%</td>
          </tr>
        </table>

        <table v-if="intakeAdmin.beleggen.profile == 'Oxby - Midden'">
          <tr style="background-color:#eee">
            <td><b>Profiel OXBY Midden</b></td>
            <td>minimaal (circa)</td>
            <td>maximaal (circa)</td>
            <td rowspan="6" style="text-align:center;border-left:1px solid #ccc;">
              <img src="../../assets/risk/risicometer3.0-5.3.svg" width="100" />
            </td>
          </tr>
          <tr>
            <td>Aandelen ontwikkelde markten</td>
            <td>40%</td>
            <td>70%</td>
          </tr>
          <tr>
            <td>Vastgoed wereldwijd</td>
            <td>5%</td>
            <td>5%</td>
          </tr>
          <tr>
            <td>Staatsleningen euro</td>
            <td>12,5%</td>
            <td>12,5%</td>
          </tr>
          <tr>
            <td>Investment grade bedrijfsobligaties euro</td>
            <td>12,5%</td>
            <td>12,5%</td>
          </tr>
          <tr>
            <td>Duitse staatsleningen euro</td>
            <td>0%</td>
            <td>30%</td>
          </tr>
          <tr>
            <td>Geldmarkt</td>
            <td>0%</td>
            <td>5%</td>
          </tr>
        </table>

        <table v-if="intakeAdmin.beleggen.profile == 'Oxby - Laag'">
          <tr style="background-color:#eee">
            <td><b>Profiel OXBY Laag</b></td>
            <td>minimaal (circa)</td>
            <td>maximaal (circa)</td>
            <td rowspan="6" style="text-align:center;border-left:1px solid #ccc;">
              <img src="../../assets/risk/risicometer3.3-4.6.svg" width="100" />
            </td>
          </tr>
          <tr>
            <td>Aandelen ontwikkelde markten</td>
            <td>25%</td>
            <td>45%</td>
          </tr>
          <tr>
            <td>Vastgoed wereldwijd</td>
            <td>5%</td>
            <td>5%</td>
          </tr>
          <tr>
            <td>Staatsleningen euro</td>
            <td>25%</td>
            <td>25%</td>
          </tr>
          <tr>
            <td>Investment grade bedrijfsobligaties euro</td>
            <td>25%</td>
            <td>25%</td>
          </tr>
          <tr>
            <td>Duitse staatsleningen euro</td>
            <td>0%</td>
            <td>20%</td>
          </tr>
          <tr>
            <td>Geldmarkt</td>
            <td>0%</td>
            <td>5%</td>
          </tr>
        </table>

        <p>
          Gedurende ons beheer kunnen
          afwijkingen ten opzichte van de bovenstaande percentages ontstaan als gevolg van
          onverwachte marktomstandigheden. De risicowijzer geeft de beweeglijkheid (volatiliteit)
          van de beleggingen in uw portefeuille aan. Dit wil zeggen de hoogte en frequentie van de
          koersschommelingen van uw beleggingsportefeuille indien deze zou zijn samengesteld conform
          het afgesproken beleggingsbeleid.
        </p>

        <h2>Benchmarks</h2>
        <p>
          Wij hanteren voor iedere beleggingscategorie een aparte benchmark. Hierdoor kun u zien hoe
          de waardeontwikkeling van uw portefeuille zich verhoudt tot de desbetreffende benchmark.
        </p>
        <table>
          <tr>
            <td>Aandelen</td>
            <td>MSCI World Index</td>
          </tr>
          <tr>
            <td>Vastgoed</td>
            <td>GPR Global 100 Total Return Index</td>
          </tr>
          <tr>
            <td>Staatsobligaties</td>
            <td>Barclays Capital Euro Government Bond 7-10</td>
          </tr>
          <tr>
            <td>Bedrijfsobligaties</td>
            <td>Markit iBoxx Euro Corporale Bond</td>
          </tr>
          <tr>
            <td>Duitse staatsobligaties</td>
            <td>eb.rexx® Government Germany 5.5-10.5</td>
          </tr>
        </table>

        <h2>Kosten van dienstverlening en beleggen</h2>
        <p>
          De tarieven die gelden voor de dienstverlening van {{ brandname }} en kosten verbonden aan
          het beleggen in effecten, in het bijzonder transactiekosten, staan vermeld op onze
          website:
          <b v-if="intakeAdmin.beleggen.brand == 'OXBY'">https://www.oxby.nl/waarom/tarieven</b>
        </p>
      </div>

      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- Duurzaamheids pagina -->
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />
        <h2>{{ brandname }} en duurzaamheid</h2>
        <p>
          Hierbij geven wij u inzicht in hoe wij duurzaamheid hebben geïntegreerd in ons
          beleggingsproces.<br /><br />
          Bij de daadwerkelijke invulling van uw portefeuille is een optimale verhouding tussen
          risico en rendement het uitgangspunt. De beleggingen worden niet geselecteerd op het
          promoten van E en/of S kenmerken, die onderdeel zijn van ESG kenmerken, dan wel het op het
          bijdragen aan duurzame doelstellingen.<br /><br />
          ESG staat voor 'Environmental', 'Social' en 'Governance'. In het Nederlands betekent dit
          'Milieu', 'Maatschappij' en 'Bestuur' en zijn niet-financiële kenmerken die kunnen worden
          gebruikt om bedrijven te beoordelen op duurzaamheid.<br /><br />
          Uiteraard zullen wij geen beleggingen voor u opnemen waarvan het bij wet verboden is om
          erin te beleggen, zoals bijvoorbeeld bedrijven die betrokken zijn bij controversiële
          wapens. Het gaat hier bijvoorbeeld om bedrijven die betrokken zijn bij het maken
          (van belangrijke onderdelen) van clusterbommen, kernwapens, antipersoonsmijnen,
          biologische en chemische wapens.<br /><br />
          Ook beleggen wij niet in obligaties van landen of bedrijven waar internationale sancties
          aan zijn opgelegd door de Verenigde Naties (VN) of door de Europese Unie (EU).
          <br /><br />
        </p>
        <h3>Duurzaamheidsrisico</h3><br />
        <p>
          Een duurzaamheidsrisico is het risico dat een belegging minder waard wordt als gevolg van
          een gebeurtenis of omstandigheid op het gebied van duurzaamheid.<br /><br />
          Voorbeelden van zulke gebeurtenissen of omstandigheden zijn klimaatverandering,
          betrokkenheid bij kinderarbeid, of schaarste aan grondstoffen. Zulke gebeurtenissen en
          omstandigheden kunnen een negatief effect hebben op de waarde van beleggingen. Zo kan
          grondstoffen schaarste ervoor zorgen dat bepaalde bedrijven minder kunnen produceren,
          waardoor aandelen in deze bedrijven in waarde kunnen verminderen.<br /><br />
          Wij beoordelen de mogelijke impact van duurzaamheidsrisico’s voor {{ brandname }} op
          eenzelfde manier als andere risico’s zoals bijvoorbeeld marktrisico’s. Al deze risico's
          resulteren niet alleen in de mogelijkheid dat het verwachte of beoogde doelvermogen niet
          wordt behaald, maar ook in tussentijdse of uiteindelijke verliezen.<br /><br />
          Bij iedere belegging kan zich in meer of mindere mate een duurzaamheidsrisico voordoen dat
          ervoor kan zorgen dat de waarde van een belegging kan dalen. Bij de selectie van een
          belegging voor {{ brandname }} baseren wij ons op de publiek bekende informatie en
          beoordelen wij het waarschijnlijke effect van alle risico’s op de beleggingen.<br /><br />
          Wij kunnen besluiten om bepaalde beleggingen niet op te nemen. Bijvoorbeeld wanneer al
          bekende duurzaamheidsrisico’s bestaan, die naar verwachting een grote negatieve invloed
          kunnen hebben op de waarde van de beleggingen.<br /><br />
          Als er hoge duurzaamheidsrisico's bij een belegging worden vaststelt, kunnen wij in
          overleg treden met de fondsmanager om de vastgestelde risico's te bespreken. Als de
          risico’s niet acceptabel zijn, kunnen wij  besluiten om de belegging te vervangen door een
          nieuwe belegging met lagere duurzaamheidsrisico's.<br /><br />
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>
    <div class="card">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" />
        <h3>Ongunstige effecten op duurzaamheidsfactoren</h3><br />
        <p>
          Beleggingen kunnen ongunstige gevolgen hebben op duurzaamheidsfactoren. Zo kunnen
          beleggingen bijvoorbeeld in negatieve zin bijdragen aan klimaatverandering, corruptie
          of verlies van biodiversiteit.<br /><br />
          Zulke ongunstige gevolgen worden nog niet meegenomen bij beleggingsbeslissingen. De reden
          hiervoor is dat wij van mening zijn dat op dit moment onvoldoende betrouwbare en
          beschikbare gegevens hebben om deze ongunstige gevolgen goed te kunnen analyseren en te
          integreren in het beleggingsproces.<br /><br />
          Zodra wij over voldoende betrouwbare data beschikken, zullen ongunstige gevolgen op
          duurzaamheidsfactoren wel mee gaan wegen in beleggingsbeslissingen
        </p>
        <h3>EU Taxonomie</h3>
        <p>
          Bij de selectie van de beleggingen is niet geselecteerd op het voldoen aan de EU-criteria
          voor ecologisch duurzame economische activiteiten.
        </p>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>

    <!-- Overige opmerkingen -->
    <div class="card" v-if="intakeAdmin.publicNote">
      <div class="print">
        <img class="ox-logo" src="../../assets/ox/OX-logo1.svg" style="width:250px;" />

        <h2>Overige opmerkingen</h2>
        <div class="msg">
          {{intakeAdmin.publicNote}}
        </div>
      </div>
      <div class="docdate">
        Beleggingsplan {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        &copy; info@oxby.nl –
        020&nbsp;555&nbsp;0011 –
        Dorpsstraat&nbsp;34 –
        1182&nbsp;JE&nbsp;Amstelveen
      </div>
      <div class="pagenumber">#{{id}} </div>
    </div>
  </div>
</template>

<script>
import { sumBy, filter } from 'lodash-es';

export default {
  name: 'IntakePlanGeneric',
  props: {
    intake: Object,
    intakeAdmin: Object,
    redo: {
      default: -1,
      type: Number,
    },
    portValue: {
      default: -1,
      type: Number,
    },
    today: Date,
    id: Number,
  },
  computed: {
    goalType() {
      if (
        (
          this.intake.goalData.type === 'levensonderhoud'
          && this.intake.goalData.box === '1'
        )
        || this.intake.goalData.type === 'netto-lijfrente-uitkerend'
        || this.intake.goalData.type === 'gouden-handdruk-uitkerend'
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    typeToGoal() {
      if (this.intake.goalData.type === 'studiekinderen') {
        return 'studie kinderen';
      }
      if (this.intake.goalData.type === 'groteaankoop') {
        return 'grote aankoop';
      }
      if (this.intake.goalData.type === 'gouden-handdruk-opbouwend') {
        return 'gouden handdruk (opbouwend)';
      }
      if (this.intake.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'gouden handdruk (uitkerend)';
      }
      if (this.intake.goalData.type === 'netto-lijfrente-opbouwend') {
        return 'Netto lijfrente (opbouwend)';
      }
      if (this.intake.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente (uitkerend)';
      }
      if (this.intake.goalData.type === 'pensioen' && this.intake.goalData.box === '1') {
        return 'pensioen (box 1)';
      }
      if (this.intake.goalData.type === 'levensonderhoud' && this.intake.goalData.box === '1') {
        return 'leefrente (box 1)';
      }
      return this.intake.goalData.type;
    },
    brandname() {
      if (this.intakeAdmin.beleggen.brand === 'VMVB') {
        return 'Velthuyse &amp; Mulder';
      }
      if (this.intakeAdmin.beleggen.brand === 'BVS') {
        return 'Beer &amp; Van Stapele';
      }
      return 'OXBY';
    },
    totalBezit() {
      return sumBy(
        filter(
          filter(
            this.intake.persoonsData,
            this.financeFilter,
          ),
          this.deathFilter,
        ),
        (o) => Number(o.spaarrekeningBedrag || 0)
          + Number(o.spaarrekeningBedrag2 || 0)
          + Number(o.spaarrekeningBedrag3 || 0)
          // beleggingen
          + Number(o.beleggingenBedrag || 0)
          + Number(o.beleggingenMeerBedrag || 0)
          + Number(o.beleggingenNogMeerBedrag || 0)
          // verkoopwaarde eigenwoning niet mee rekenen!
          // verkoopwaarde onroerendgoed
          + Number(o.onroerendgoedVrijeverkoopwaarde || 0),
      );
    },
  },
  methods: {
    filter,
    sumBy,
    financeFilter(o) {
      if (this.intake.rekeningData.type === 'Minderjarige rekening' && o.type !== 'Minderjarige') {
        return true;
      }
      if (
        this.intake.rekeningData.type === 'Particuliere rekening'
        && o.type !== 'Volmacht'
      ) {
        return true;
      }
      if (this.intake.rekeningData.type === 'Bedrijfsrekening' && o.type !== 'Volmacht') {
        return true;
      }
      return false;
    },
    deathFilter(o) {
      return !o.sterfteDatum;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../scss/_paper.scss";
</style>
